import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./fieldset-subtitle.module.scss";

export interface IFieldsetSubtitle {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetSubtitle = (props: IFieldsetSubtitle) => {
  return (
    <div className={cx(styles.fieldset_subtitle, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

FieldsetSubtitle.defaultProps = {};
